import React from 'react';

import { Alert, AlertTitle } from '@mui/material';

import { useAuthCredentials } from '@hrlogics/react-auth';

import { FullscreenLoader } from 'src/components/common';
import { useCurrentUserAuthStatus } from 'src/hooks/auth';

import { MfaLoginForm, MfaVerificationCodeForm } from './components';

export const SetupMfaPageContent: React.FC = () => {
  const { accessToken } = useAuthCredentials();
  const { isMfaEnabled, loading } = useCurrentUserAuthStatus();

  // For the case when we open the form already authorized
  const [isImmediateVerification, setIsImmediateVerification] = React.useState(true);

  const handleLoginAction = React.useCallback(() => {
    setIsImmediateVerification(false);
  }, []);

  if (loading) {
    return <FullscreenLoader />;
  }
  if (isMfaEnabled) {
    return (
      <Alert
        variant="outlined"
        severity="info"
        sx={{ color: 'primary.main', borderColor: 'primary.main' }}
        icon={false}
      >
        <AlertTitle>Active</AlertTitle>You have set up a Multi-factor Authentication. To enter to
        the platform, you need to enter security code from an authentication app.
      </Alert>
    );
  }
  if (!accessToken) {
    return <MfaLoginForm handleLoginAction={handleLoginAction} />;
  }

  return <MfaVerificationCodeForm isImmediateVerification={isImmediateVerification} />;
};
